<template>
  <div id="AccountTransactions" class="Main-Content">

    <Page
      :title="$t('Transactions')"
      size="fullWidth"
    >
      <LoadingLayout v-if="domainsLoading"/>
      <Layout v-else >
        <LayoutSection>
          <Sheet
            :title="$t('Transaction Details')"
            :visible="!!currItem"
            :width="700"
            padded
            @close="currItem = null"
          >
            <Card
              v-if="currItem"
              :title="$t('Summary')"
            >
              <CardSection>
                <Stats>
                  <Stat
                    :label="$t('Date')"
                    type="dateTimeLong"
                    :value="currItem.orderDate"
                  ></Stat>
                  <Stat
                    :label="$t('Domain')"
                  >{{currItem.domain}}</Stat>
                  <Stat
                    :label="$t('Fanplayr Assisted')"
                  >{{currItem.isFPConversion ? true : false}}</Stat>
                </Stats>
                <!-- <pre>{{currItem}}</pre> -->
              </CardSection>
            </Card>
            <Card
              v-if="currItem"
              :title="$t('Session summary')"
            >
              <CardSection>
                <Stats>
                  <Stat
                    :label="$t('Session Key')"
                  >
                    <a
                      :href="'/#/sessionViewer/?sk=' + currItem.sessionKey"
                      target="_blank"
                    >{{currItem.sessionKey}}</a>
                  </Stat>
                  <Stat
                    :label="$t('Start Time')"
                    type="dateTimeLong"
                    :value="currItem.startTime"
                  ></Stat>
                  <Stat
                    :label="$t('End Time')"
                    type="dateTimeLong"
                    :value="currItem.endTime"
                  ></Stat>
                  <Stat
                    :label="$t('Duration')"
                    type="duration"
                    :value="[currItem.startTime, currItem.endTime]"
                  ></Stat>
                  <Stat
                    :label="$t('A/B Testing')"
                  >{{currItem.abGroup}}</Stat>
                  <Stat
                    :label="$t('Page Views')"
                    type="integer"
                    :value="currItem.pageViews"
                  ></Stat>
                  <Stat
                    :label="$t('# Cart Views')"
                    type="integer"
                    :value="currItem.numCartViews"
                  ></Stat>
                  <Stat
                    :label="$t('# Offers Collected')"
                    type="integer"
                    :value="currItem.numCouponsCollected"
                  ></Stat>
                  <Stat
                    :label="$t('# Decision Pages')"
                    type="integer"
                    :value="currItem.numDecisionPageViews"
                  ></Stat>
                  <Stat
                    :label="$t('IP Address')"
                    :value="currItem.ipAddress"
                  ></Stat>
                </Stats>
              </CardSection>
            </Card>
            <Card
              v-if="currItem && currItem.orderNumber"
              :title="$t('Order summary')"
            >
              <CardSection>
                <Stats>
                  <Stat
                    :label="$t('Order Number')"
                  >{{currItem.orderNumber}}
                  </Stat>
                  <Stat
                    :label="$t('Date')"
                    type="dateTimeLong"
                    :value="currItem.orderDate"
                  ></Stat>
                  <Stat
                    :label="$t('Currency')"
                    :value="currItem.currency"
                  ></Stat>
                  <Stat
                    :label="$t('Conversion Rate')"
                    :value="currItem.conversionRate"
                  ></Stat>
                  <Stat
                    :label="$t('Gross')"
                    type="currency"
                    :currency="theUser.accountCurrency"
                    :value="currItem.orderGross"
                  ></Stat>
                  <Stat
                    :label="$t('Gross (Local)')"
                    type="currency"
                    :currency="currItem.currency"
                    :value="currItem.orderGrossLocalCurrency"
                  ></Stat>
                  <Stat
                    :label="$t('Discount')"
                    type="currency"
                    :currency="theUser.accountCurrency"
                    :value="currItem.discount"
                  ></Stat>
                  <Stat
                    :label="$t('Discount (Local)')"
                    type="currency"
                    :currency="currItem.currency"
                    :value="currItem.discountLocalCurrency"
                  ></Stat>
                  <Stat
                    :label="$t('Discount Code')"
                    :value="currItem.discountCode"
                  ></Stat>
                  <Stat
                    :label="$t('Email')"
                    :value="currItem.email"
                  ></Stat>
                </Stats>
              </CardSection>
            </Card>
            <!-- <pre>{{currItem}}</pre> -->
          </Sheet>
          <Card :actions="[{
            label: $t('Download'),
            onAction: startDownload,
            disabled: !formattedTransactions.length || exporting
          }]">
            <Filters
              ref="filters"
              :filters="[
                {
                  key: 'startDate',
                  label: $t('Start Date'),
                  type: 'date',
                  required: true
                },
                {
                  key: 'endDate',
                  label: $t('End Date'),
                  type: 'date',
                  endOfDay: true
                },
                {
                  key: 'orderNumber',
                  label: $t('Order Number'),
                  type: 'text'
                },
                {
                  key: 'discountCode',
                  label: $t('Discount Code'),
                  type: 'text'
                },
                {
                  key: 'domain',
                  label: $t('Domain'),
                  placeholder: $t('Choose a domain'),
                  type: 'select',
                  multiple: true,
                  options: domainList
                },
                {
                  key: 'isFPConversion',
                  label: $t('Attribution'),
                  placeholder: $t('Choose a value'),
                  type: 'select',
                  options: [
                    {
                      label: $t('Fanplayr'),
                      value: true
                    },
                    {
                      label: $t('Non-Fanplayr'),
                      value: false
                    }
                  ]
                }
              ]"
              :shortcuts="[
                {
                  label: $t('Date'),
                  items: [
                    { label: $t('Current month'), onAction: () => setDateCurrentMonth() },
                    { label: $t('Today'), onAction: () => setDateShort(0) },
                    { label: $t('Yesterday'), onAction: () => setDateShort(1) },
                    { label: $t('Last 7 days'), onAction: () => setDateShort(7) },
                    { label: $t('Last 15 days'), onAction: () => setDateShort(15) },
                    { label: $t('Last 30 days'), onAction: () => setDateShort(30) },
                    { label: $t('All Time'), onAction: () => {
                      this.filter.startDate = '2010-01-01';
                      this.filter.endDate = '';
                      this.offset = 0
                      this.filterResults()
                    }},
                    { label: $t('Custom'), onAction: () => this.$refs.filters.open() }
                  ]
                },
                {
                  label: $t('Attribution'),
                  items: [
                    { label: $t('Fanplayr'), onAction: () => setIsFP(true) },
                    { label: $t('Non-Fanplayr'), onAction: () => setIsFP(false) }
                  ]
                }
              ]"
              :applied-filters="filter"
              @update="updateFilters"
              :query="false"
            />
            <DataTable
              :columns="[
                {
                  key: 'orderNumber',
                  label: $t('Order Number')
                },
                {
                  key: 'orderDate',
                  label: $t('Date'),
                  format: 'dateTimeShort'
                },
                {
                  key: 'orderGross',
                  label: $t('Amount'),
                  format: 'currency',
                  formatContext: context
                },
                {
                  key: 'discount',
                  label: $t('Discount'),
                  format: 'currency',
                  formatContext: context
                },
                {
                  key: 'discountCode',
                  label: $t('Discount Code')
                },
                {
                  key: 'net',
                  label: $t('Net Amount'),
                  format: 'currency',
                  formatContext: context
                }
              ]"
              :rows="formattedTransactions"
              :pagination="{
                offset: offset,
                limit: limit,
                total: totalElements,
                updateOffset: setOffset,
                updateLimit: updateLimit
              }"
              :totals="['', '', orderTotal, discountTotal, '', '']"
              :loading="loadingState"
              @click-row="row => currItem = row"
            />
          </Card>
        </LayoutSection>
      </Layout>
    </Page>
  </div>
</template>

<script>
import _ from 'lodash'
import Utils from '../classes/utils/Utils'
export default {
  name: 'AccountTransactions',
  data () {
    return {
      loading: true,
      exporting: false,
      totalsLoading: true,
      domainsLoading: true,
      filter: {
        startDate: null,
        endDate: null,
        orderNumber: null,
        ipAddress: null,
        domain: null,
        isFPConversion: null
      },
      offset: 0,
      limit: null,
      totalElements: null,
      discountTotal: null,
      orderTotal: null,
      accountCurrency: null,
      domains: [],
      transactions: [],
      currItem: null,
      sortBy: {
        column: 'orderDate',
        direction: 'desc'
      },
      cancelableTransactions: null,
      cancelableTotals: null
    }
  },
  async mounted() {
    NProgress.start()

    await this.setFilterFromQuery(false)

    this.$watch('$route', async () => {
      await this.setFilterFromQuery(true)
    }, { deep: true })

    this.limit = this.getTableLimit('tableLimit') || 10
    this.cancelableTransactions = Utils.makeCancelablePromise(
      this.api.getTransactions(this.filter, this.limit, this.offset)
    )
    this.cancelableTransactions.promise
      .then((trans) => {
        this.transactions = trans
        this.loading = false
      })
      .catch((e) => {
        if (!e.isCanceled) {
          this.apiCatch(e)
        }
      })
      .finally(() => {
        NProgress.done()
      })
    
    this.api.getDomains()
      .then((domains) => {
        this.domains = domains
        this.domainsLoading = false
      })
      .catch(this.apiCatch)

    this.cancelableTotals = Utils.makeCancelablePromise(
      this.api.getTransactionTotals(this.filter)
    )
    this.cancelableTotals.promise
      .then((data) => {
        this.totalElements = data.count
        this.discountTotal = data.discountTotal
        this.orderTotal = data.orderTotal
        this.totalsLoading = false
      }) 
      .catch((e) => {
        if (!e.isCanceled) {
          this.apiCatch(e)
        }
      })
  },
  computed: {
    loadingState() {
      return {
        rows: this.loading,
        totals: this.totalsLoading,
        footer: this.totalsLoading
      }
    },
    formattedTransactions() {
      let transactions = this.transactions.map(t => {
        return {
          ...t,
          abGroup: this.getAbGroup(t.omittedByAb),
          net: t.orderGross - t.discount
        }
      })
      if (this.sortBy) {
        transactions = _.orderBy(transactions, [this.sortBy.column], [this.sortBy.direction])
      }
      return transactions
    },
    domainList() {
      return this.domains.map(d => {
        return {
          label: d.domain,
          value: d.domain
        }
      })
    },
    currentItemRules() {
      const item = this.currItem
      if (item) {
        return this.getConversionTextLines(item)
      }
      return []
    }
  },
  methods: {
    async setFilterFromQuery(makeApiCall = false) {
      if (this.$route.query) {
        this.filter = {}
        Object.keys(this.$route.query).forEach((k) => {
          if (this.$route.query[k] !== null) {
            if (k === 'isFPConversion') {
              this.filter[k] = typeof this.$route.query[k] === 'boolean' ? this.$route.query[k] : this.$route.query[k] === 'true'
            } else if (k === 'domain') {
              if (Array.isArray(this.$route.query.domain)) {
                this.filter[k] = this.$route.query.domain
              } else {
                this.filter[k] = [this.$route.query.domain]
              }
            } else {
              this.filter[k] = this.$route.query[k]
            }
          } else {
            this.filter[k] = null
          }
        })
      }
      if (!this.filter.startDate) {
        this.filter.startDate = window.moment().startOf('month').format('YYYY-MM-DD')
      }

      await this.$router.replace({ name: 'AccountTransactions', query: this.filter})
      .catch(this.duplicateRouteCatch)

      if (makeApiCall) {
        this.filterResults(true)
      }
    },
    context() {
      return {
        currency: this.theUser.accountCurrency || 'USD'
      }
    },
    updateLimit(limit) {
      this.setTableLimit('tableLimit', limit)
      this.limit = limit
      this.offset = 0
      this.filterResults(false)
    },
    updateUrl() {
      this.$router.push({ name: 'AccountTransactions', query: this.filter})
      .catch(this.duplicateRouteCatch)
    },
    filterResults(refreshTotals = true) {
      this.updateUrl()
      NProgress.start()
      this.loading = true
      this.cancelableTransactions.cancel()
      this.cancelableTransactions = Utils.makeCancelablePromise(
        this.api.getTransactions(this.filter, this.limit, this.offset)
      )
      this.cancelableTransactions.promise
        .then((data) => {
          this.transactions = data
          this.loading = false
        })
        .catch((e) => {
          if (!e.isCanceled) {
            this.apiCatch(e)
          }
        })
        .finally(() => {
          NProgress.done()
        })

      if (refreshTotals) {
        this.clearTotals()
        this.totalsLoading = true
        this.cancelableTotals.cancel()
        this.cancelableTotals = Utils.makeCancelablePromise(this.api.getTransactionTotals(this.filter))
        this.cancelableTotals.promise
          .then((data) => {
            this.totalElements = data.count
            this.discountTotal = data.discountTotal
            this.orderTotal = data.orderTotal
            this.totalsLoading = false
          })
          .catch((e) => {
            if (!e.isCanceled) {
              this.apiCatch(e)
            }
          })
      }
    },
    clearTotals() {
      this.totalElements = null
      this.discountTotal = null
      this.orderTotal = null
    },
    setDateShort(offset) {
      let start = 0
      let end = 0
      if (offset === 1) {
        start = end = 1
      }
      if (offset > 1) {
        start = offset
        end = 0
      }
      this.filter.startDate =  window.moment.tz(window.moment().utc(), 'UTC')
        .tz(this.theUser.accountTimezone)
        .subtract(start, 'days')
        .format('YYYY-MM-DD')
      this.filter.endDate = window.moment.tz(window.moment().utc(), 'UTC')
        .tz(this.theUser.accountTimezone)
        .subtract(end, 'days')
        .format('YYYY-MM-DD')
      this.offset = 0
      this.filterResults()
    },
    setDateCurrentMonth() {
      this.filter.endDate = null
      this.filter.startDate = window.moment().startOf('month').format('YYYY-MM-DD')
      this.offset = 0
      this.filterResults()
    },
    updateFilters(filter) {
      this.filter = filter
      this.offset = 0
      this.filterResults()
    },
    setOffset(offset) {
      this.offset = offset
      this.filterResults(false)
    },
    setIsFP(value) {
      this.filter.isFPConversion = value
      this.filterResults()
    },
    setType(value) {
      this.filter.conversionType = value
      this.filterResults()
    },
    getAbGroup(omittedByAb) {
      if (omittedByAb === false) {
        return this.$t('Targeted')
      } else if (omittedByAb === true) {
        return this.$t('Control')
      }
      return this.$t('Not-Targeted')
    },
    startDownload() {
      NProgress.start()
      this.exporting = true
      this.api.getTransactionsExportUrl(this.filter)
        .then((response) => {
          if (response.file) {
            window.open(response.file)
          } else {
            this.eventHub.$emit('startBackgroundProcess')
          }
        })
        .catch(this.apiCatch)
        .finally(() => {
          this.exporting = false
          NProgress.done()
        })
    },
  }
}

</script>
